// import { host } from '../constants'
// import { postToApi } from 'venuescanner-js/services/api'
import controllers from "venuescanner-js/services/controllers";
import isSSR from "venuescanner-js/services/isSSR";

export const reportError = (pkg, error, errorInfo = {}, extra = {}) => {
  if (isSSR()) return; // SSR
  controllers.error.error.post({
    package: pkg,
    error: {
      name: error.name,
      message: error.message,
      stack: error.stack,
    },
    errorInfo,
    extra,
    url: window.location.href,
  });
};
